import React, { useState } from 'react';
import { LoggedInNav } from '../components/LoggedInNav';
import { PlusIcon, EditIcon, TrashIcon } from 'lucide-react';
import { NewPromptModal } from '../components/NewPromptModal';
// Example prompt data structure
interface Prompt {
  id: string;
  text: string;
  createdAt: Date;
  lastUsed?: Date;
}
export function Prompts() {
  const [prompts, setPrompts] = useState<Prompt[]>([{
    id: '1',
    text: 'Perform a find win keep analysis for each customer if it is within the first 5 meetings with the customer.',
    createdAt: new Date('2023-11-01'),
    lastUsed: new Date('2023-11-10')
  }, {
    id: '2',
    text: 'Analyze the competitive landscape and identify key differentiators for our product.',
    createdAt: new Date('2023-10-15')
  }, {
    id: '3',
    text: "Summarize the client's business challenges and propose three potential solutions.",
    createdAt: new Date('2023-10-25'),
    lastUsed: new Date('2023-11-05')
  }]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingPrompt, setEditingPrompt] = useState<Prompt | null>(null);
  const handleSavePrompt = (promptText: string) => {
    if (editingPrompt) {
      // Update existing prompt
      setPrompts(prompts.map(p => p.id === editingPrompt.id ? {
        ...p,
        text: promptText
      } : p));
    } else {
      // Add new prompt
      const newPrompt: Prompt = {
        id: Date.now().toString(),
        text: promptText,
        createdAt: new Date()
      };
      setPrompts([...prompts, newPrompt]);
    }
    setIsModalOpen(false);
    setEditingPrompt(null);
  };
  const handleDeletePrompt = (id: string) => {
    setPrompts(prompts.filter(p => p.id !== id));
  };
  const handleEditPrompt = (prompt: Prompt) => {
    setEditingPrompt(prompt);
    setIsModalOpen(true);
  };
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  return <div className="min-h-screen bg-[#1A2331] text-[#F5F7FA]" data-id="element-3159">
      <LoggedInNav data-id="element-3160" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3161">
        <div className="flex justify-between items-center mb-8" data-id="element-3162">
          <h1 className="text-3xl font-bold" data-id="element-3163">Custom Prompts</h1>
          <button onClick={() => {
          setEditingPrompt(null);
          setIsModalOpen(true);
        }} className="flex items-center px-4 py-2 bg-[#C8F169] text-[#1A2331] rounded-md font-medium hover:bg-opacity-90 transition-colors" data-id="element-3164">
            <PlusIcon className="w-5 h-5 mr-2" data-id="element-3165" />
            New Prompt
          </button>
        </div>
        <div className="bg-[#1E2A38] rounded-lg shadow-xl p-6" data-id="element-3166">
          <div className="grid gap-6" data-id="element-3167">
            {prompts.length === 0 ? <div className="text-center py-12" data-id="element-3168">
                <p className="text-[#F5F7FA] text-opacity-70 mb-4" data-id="element-3169">
                  You haven't created any custom prompts yet.
                </p>
                <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center px-4 py-2 bg-[#C8F169] text-[#1A2331] rounded-md font-medium hover:bg-opacity-90 transition-colors" data-id="element-3170">
                  <PlusIcon className="w-5 h-5 mr-2" data-id="element-3171" />
                  Create your first prompt
                </button>
              </div> : prompts.map(prompt => <div key={prompt.id} className="bg-[#263445] rounded-lg p-5 hover:bg-[#2A3A4D] transition-colors" data-id="element-3172">
                  <div className="flex justify-between" data-id="element-3173">
                    <div className="flex-1" data-id="element-3174">
                      <p className="text-[#F5F7FA] mb-3" data-id="element-3175">{prompt.text}</p>
                      <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-60" data-id="element-3176">
                        <span data-id="element-3177">Created: {formatDate(prompt.createdAt)}</span>
                        {prompt.lastUsed && <span className="ml-4" data-id="element-3178">
                            Last used: {formatDate(prompt.lastUsed)}
                          </span>}
                      </div>
                    </div>
                    <div className="flex items-start ml-4 space-x-2" data-id="element-3179">
                      <button onClick={() => handleEditPrompt(prompt)} className="p-2 text-[#F5F7FA] text-opacity-70 hover:text-[#C8F169] transition-colors" data-id="element-3180">
                        <EditIcon className="w-5 h-5" data-id="element-3181" />
                      </button>
                      <button onClick={() => handleDeletePrompt(prompt.id)} className="p-2 text-[#F5F7FA] text-opacity-70 hover:text-red-400 transition-colors" data-id="element-3182">
                        <TrashIcon className="w-5 h-5" data-id="element-3183" />
                      </button>
                    </div>
                  </div>
                </div>)}
          </div>
        </div>
      </div>
      {isModalOpen && <NewPromptModal initialText={editingPrompt?.text || ''} onClose={() => {
      setIsModalOpen(false);
      setEditingPrompt(null);
    }} onSave={handleSavePrompt} isEditing={!!editingPrompt} data-id="element-3184" />}
    </div>;
}